import { useEffect, useState } from "react";
import ExpertDataService from "../services/Expert";
import { useNavigate } from "react-router-dom";
import { Flex, useToast, Input, Button, Box } from "@chakra-ui/react";
import { SingleExpertTreatmentPlanRow } from "../components/List/SingleExpertTreatmentPlanRow";
import { default as ReactSelect } from "react-select";
import { Loader } from "../components/Loader/Loader";

export const ExpertTreatmentPlanList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const [list, setList] = useState<any>();

  const [expertList, setExpertList] = useState<any>([]);
  const [expertId, setExpertId] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const fetchData = async () => {
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);

      setIsLoading(true);
      const res = await ExpertDataService.getAllTreatmentPlan(
        expertId,
        userEmail
      );

      const plans = res.data.data;

      const expertMap = new Map(
        expertRes.data.map((e: any) => [e._id, e.data?.full_name || ""])
      );

      const merged = plans.map((plan: any) => ({
        ...plan,
        expertName: expertMap.get(plan.expert_id) || "",
      }));

      const sorted = merged.sort((a: any, b: any) =>
        a.expertName.localeCompare(b.expertName)
      );

      setList(sorted);
      // setList(res.data.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [expertId]);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - Treatment Plans</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className=" p-4">
          <Flex p={4} alignItems="start" justifyContent="end" gap={8}>
            <Box w="270px">
              <ReactSelect
                id="expert"
                name="expert"
                options={options}
                placeholder="Filter Expert"
                isClearable
                value={options.find((option: any) => option.value === expertId)}
                onChange={(option) => setExpertId(option ? option.value : "")}
                classNamePrefix="react-select"
              />
            </Box>
            <Flex display="flex" alignItems="flex-end" w="350px">
              <Input
                id="searchquery"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="Search By Email"
                borderRadius="md"
                borderRightRadius={0}
                borderWidth="1px"
                color="#327171"
                bg="white"
                focusBorderColor="transparent"
                // _placeholder={{ color: "gray.500" }}
                borderColor="#327171"
                _hover={{ borderColor: "gray.200" }}
                _focus={{ borderColor: "gray.200" }}
              />
              <Button
                size="md"
                borderRadius="md"
                borderLeftRadius={0}
                p={5}
                colorScheme="whiteAlpha"
                bg="#327171"
                onClick={() => fetchData()}
              >
                Search
              </Button>
            </Flex>
          </Flex>

          <div className="main-section" style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Expert Name</th>
                  <th>Client Email</th>
                  <th>Treatment Plan</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleExpertTreatmentPlanRow
                      key={el._id}
                      props={el}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
